export default __webpack_public_path__ + "static/media/bkg--location-aerial.3c3c1443.jpg";